import React from 'react';
import {getContainer} from '../../ioc/IOCSetup';
import "../SportsView.scss";
import {connect} from "react-redux";
import {Dispatch} from "redux";
import Page from "../../layout/Page";
import {fetchSettings} from "../../settings/SettingsActions";
import {AppState} from "../../RootReducer";
import {LaunchUrl, Settings} from "../../http/protocol";
import {LoginStatus} from '../../http/Types';
import {ContentModelName, PopupManager} from "../../contenful/types";
import {fetchContent} from "../../contenful/ContentfulActions";
import {ReactComponent as Spinner} from "../../assets/ball_loader.svg";
import {progressBar} from "../../utils/ProgressBar";
import {Redirect, withRouter, RouteComponentProps} from 'react-router';
import { Device } from '../../utils/Device';
import { PATH } from '../../onboardingpage/modalview/UserModalController';


interface Props extends RouteComponentProps {
    settings : Settings,
    fetchSettings : typeof fetchSettings,
    loggedIn?: boolean;
    currency?: string;
    popupManager?: PopupManager;
    fetchContent : typeof fetchContent;
    lng: string;
    mobile?: boolean;
};

interface State {
    sportsbookUrl?: string|undefined;
    iframeHeight?: number;
    loading:boolean;
    // hideAfterWentToOtherPage: boolean;
    progress:number;
    manualProgressIncrease:boolean;
    loginToBet:boolean;
}

export class SabaSportsComponent extends React.Component<Props, State>{
    listener: any;
    progressInterval : any;
    constructor(props : Props){
        super(props);
        let heightOffset = 80;
        if(window.innerWidth <= 1200) {
            heightOffset = 110;
        }
        this.state = { iframeHeight : window.innerHeight-heightOffset, loading:true, progress: 0, manualProgressIncrease:true, loginToBet:false };
    }

    async componentDidMount(): Promise<void> {
        this.startProgress();

        document.getElementById("sportsbook-iframe")!.addEventListener("load", () => {
            this.clearProgressInterval()
            this.setState({loading: false})
        })


        this.listener = window.addEventListener("resize", ()=> {
            let heightOffset = 80;
            if(window.innerWidth <= 1200) {
                heightOffset = 110;
            }
            this.setState({iframeHeight:window.innerHeight-heightOffset})
        },false);

        if(this.props.settings == undefined) {
            this.props.fetchSettings();
        }

        let locale = getContainer().getSettingsService().getActiveLocale().code;
        const currencyOnLoad = this.props.currency || "EUR";

        let url;

        const mobile = Device.isMobile()

        if(this.props.loggedIn) {
            url = await getContainer().getSportsbookService().getSabaGameLaunchUrl(currencyOnLoad, locale, mobile)
        } else {
            url = await getContainer().getSportsbookService().getSabaAnonymousGameLaunchUrl(locale, mobile)
        }



        this.setState({ sportsbookUrl : url.url });
    }

    private clearProgressInterval() {
        if (this.progressInterval) {
            clearInterval(this.progressInterval);
            this.progressInterval = undefined;
        }
    }

    startProgress () {
        setTimeout(() => {
            if (this.state.loading) {
                this.setState({loading:false})
                this.clearProgressInterval();
            }
        }, 60000)

        this.clearProgressInterval()
        let current_progress:number = 0;
        let step:number = 0.1;
        this.setState({progress:0, loading: true})

        const rnd = Math.random() * 1000

        this.progressInterval = setInterval(() => {
            if(this.state.manualProgressIncrease) {
                current_progress += step;
                let progress:number = Math.round(Math.atan(current_progress) / (Math.PI / 2) * 98 * 1000) / 1000;
                if(this.state.progress > 35) {
                    step = 0.4
                }
                this.setState({progress:progress})
            }
        }, 200);
    }

    async componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        let locale = getContainer().getSettingsService().getActiveLocale().code;

        const loginChanged = prevProps.loggedIn != this.props.loggedIn
        const currencyChanged = prevProps.currency != this.props.currency

        if (loginChanged  ||  currencyChanged) {
            await this.setState({ sportsbookUrl: undefined, loading: true, progress : 0, manualProgressIncrease:true})

            let url;
            const mobile = Device.isMobile()

            if (this.props.loggedIn  &&  this.props.currency) {
                url = await getContainer().getSportsbookService().getSabaGameLaunchUrl(this.props.currency, locale, mobile)
            } else {
                url = await getContainer().getSportsbookService().getSabaAnonymousGameLaunchUrl(locale, mobile)
            }
            
            await this.setState({ sportsbookUrl : url.url })
            this.startProgress()
        }

    }

    componentWillUnmount(): void {
        clearInterval(this.progressInterval);
        // window.removeEventListener("message", this.listener);
    }

    render() {
        if(this.state.loginToBet) {
            return <Redirect to={{search: new URLSearchParams({type: PATH.LOGIN, modal: PATH.MODAL_TYPE}).toString()}} />
        }
        return (
            <div>
                {this.state.loading && <div className="preloader">
                    <Spinner/>
                    {progressBar(this.state.progress, "100px", "2px")}
                </div>}
                <Page>
                    <iframe
                        id="sportsbook-iframe"
                        name="sportsbook-iframe"
                        scrolling="yes"
                        width={"100%"}
                        height={this.state.iframeHeight}
                        className={`sportsbook-iframe saba ${this.props.loggedIn ? 'authenticated' : 'anonymous'} `}
                        frameBorder={0}
                        allowFullScreen={false}
                        src={this.state.sportsbookUrl}
                    />
                </Page>
            </div>
        )
    }
}

const stateToProps = (app : AppState) => {
    return {
        settings: app.settings.settings ? app.settings.settings : {},
        loggedIn : app.user.status == LoginStatus.LOGGED_IN,
        currency: app.user.activeCurrency,
        popupManager: app.contentful.popupManager,
        mobile : app.settings.mobile
    }
};

const dispatchToProps = (dispatch : Dispatch) => (
    {
        fetchSettings : () => dispatch(fetchSettings() as any),
        fetchContent : (contentModelName : ContentModelName) => dispatch(fetchContent(contentModelName) as any),

    }
);

const SabaSportsComponentWithRouter = withRouter(SabaSportsComponent);

export default connect(stateToProps, dispatchToProps)(SabaSportsComponentWithRouter)

